export default __webpack_public_path__ + "static/media/AvatarKids-08.d2beebf5.png";